import { render, staticRenderFns } from "./ShapeSize.vue?vue&type=template&id=502211a8&scoped=true&"
import script from "./ShapeSize.vue?vue&type=script&lang=js&"
export * from "./ShapeSize.vue?vue&type=script&lang=js&"
import style0 from "./ShapeSize.vue?vue&type=style&index=0&id=502211a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502211a8",
  null
  
)

export default component.exports